import React from 'react';
import { ElasticManager } from '@dtsl/jsutils/dist/elasticWrapper';
import { FULLSTORY_DOMAIN_MAPPING } from '../../constants';

interface User {
  id: number | undefined;
  displayName: string;
  isExpert: boolean;
  photoURL: string | undefined;
  auth_token: string | undefined;
  sib_int_organization_id: number | undefined;
}

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallBackComponent: () => React.ReactElement;
  user?: User | null;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    const { user } = this.props;

    if (user) {
      const rawSessionUrl = (window as any).FS?.getCurrentSessionURL?.();
      const sessionUrl = rawSessionUrl
        ? rawSessionUrl.replace(FULLSTORY_DOMAIN_MAPPING.FROM, FULLSTORY_DOMAIN_MAPPING.TO)
        : '';
      const data = {
        id: user.sib_int_organization_id?.toString() || '',
        url: window.location.href,
        app: 'video-calls',
        status: 1000,
        sessionUrl,
      };

      ElasticManager.methodInitiator('captureError', [
        {
          name: 'CrashError',
          message: error?.toString(),
          errorStackTrace: error?.stack,
          componentStack: errorInfo?.componentStack,
          ...data,
        },
      ]);
    }
  }

  render(): React.ReactNode {
    const { fallBackComponent, children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return fallBackComponent();
    }

    return children;
  }
}

export default ErrorBoundary;
